import Globalize from "globalize";
import CurrencyData from "cldr-data/supplemental/currencyData.json";
import Plural from "cldr-data/supplemental/plurals.json";
import LikelySubtags from "cldr-data/supplemental/likelySubtags.json";
import locales from "../../config/locales.json";
import siteConfig from "site-config";

/* HACK for a HACK */
CurrencyData.supplemental.currencyData.fractions.USI = {
    _digits: "2",
    _rounding: "0",
};

Globalize.load(CurrencyData, LikelySubtags, Plural);

export default function (forcedLocal, callback) {
    const loc =
        forcedLocal ||
        (navigator.languages && navigator.languages.length > 0
            ? navigator.languages[0]
            : navigator.language || navigator.userLanguage);

    const language = locales.localeToLang[loc.toLowerCase()] || locales.defaultLang;
    const cldr = locales.cldrMap[language] || language;

    const fetchCldrPromise = fetch(`${siteConfig.assetPath}/locales/${cldr}.json?_v=${process.env.version}`).then(
        (response) => response.json(),
    );
    const fetchMessagesPromise = fetch(
        `${siteConfig.assetPath}/messages/${language}.json?_v=${process.env.version}`,
    ).then((response) => response.json());

    Promise.all([fetchCldrPromise, fetchMessagesPromise]).then(([cldrData, messages]) => {
        // HACK FOR USI
        if (cldrData.main[language]) {
            cldrData.main[language].numbers.currencies.USI = {
                displayName: "US Dollar",
                "displayName-count-one": "US dollar",
                "displayName-count-other": "US dollars",
                symbol: "$",
                "symbol-alt-narrow": "$",
            };
        }
        Globalize.load(cldrData);
        Globalize.loadMessages(messages);

        Globalize.locale(language);
        callback();
    });
}
